/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import DailyClosingEvent from '../../event/DailyClosingEvent'
import UserEvent from '../../event/UserEvent'
import ReservationEvent from '../../event/ReservationEvent'
import { DailyClosingHeadState } from '../state/DailyClosingHeadState'
import LocalDate from '../../domain/type/Date'

class DailyClosingHeadStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new DailyClosingHeadState()
  }

  reduce(state, action) {
    const payload = action.payload
    let closeDate = null
    let closeMonth = null

    switch (action.type) {
      case DailyClosingEvent.initialize:
        closeDate = new LocalDate(payload.close_date)
        closeMonth = closeDate.beginningOfMonth()

        return state.clear().merge({
          close_date: closeDate,
          monthly_close_date: closeMonth,
          monthly_close_date_year: closeMonth.year,
          monthly_close_date_month: closeMonth.month
        })

      case UserEvent.fetchUserRoomById:
        return state.merge({
          room_id: payload.room.id,
          room_name: payload.room.name
        })

      case ReservationEvent.fetchOne:
        return state.addReservation(payload.reservation)

      case DailyClosingEvent.fetchOne:
        return state.mergeModel(payload.daily_closing_head).setReservations(payload.reservations)

      case DailyClosingEvent.onEdit:
        let year = state.monthly_close_date.year
        let month = state.monthly_close_date.month
        let date = null

        switch (payload.name) {
          case 'monthly_close_date_year':
            year = parseInt(payload.value)
            date = LocalDate.of(year, month, 1)
            return state.merge({ monthly_close_date: date, monthly_close_date_year: year, monthly_close_date_month: month })

          case 'monthly_close_date_month':
            month = parseInt(payload.value)
            date = LocalDate.of(year, month, 1)
            return state.merge({ monthly_close_date: date, monthly_close_date_year: year, monthly_close_date_month: month })

          case 'close_date':
            const close_date = new LocalDate(payload.value)
            return state.merge({ close_date: close_date })
        }

        return state.set(payload.name, payload.value)

      case DailyClosingEvent.addReservation:
        // FIXME TODO check_outベースで締め日、締め月を設定している
        closeDate = new LocalDate(payload.reservation.check_out)
        closeMonth = closeDate.beginningOfMonth()

        return state.merge({
          close_date: closeDate,
          monthly_close_date: closeMonth,
          monthly_close_date_year: closeMonth.year,
          monthly_close_date_month: closeMonth.month
        })

      case DailyClosingEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new DailyClosingHeadStore()
